const key = (uuid: string) => `trustpulse-voter-${uuid}`;

const fallback = new Map<string, string>();

/**
 * An anonymous token kept in the browser, so one person's picks can be changed and counted once.
 * Without storage, as in a private window, the token lasts as long as the page.
 */
export const voterToken = (uuid: string): string => {
  try {
    const stored = localStorage.getItem(key(uuid));
    if (stored) return stored;
    const created = crypto.randomUUID();
    localStorage.setItem(key(uuid), created);
    return created;
  } catch {
    const created = fallback.get(uuid) ?? crypto.randomUUID();
    fallback.set(uuid, created);
    return created;
  }
};
